'use client';

import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './constants';

let isInitialized = false;

export const initializeAmplify = () => {
    if (typeof window !== 'undefined' && !isInitialized) {
        Amplify.configure(amplifyConfig);
        isInitialized = true;
    }
};
